import React from "react";
import { useTranslation } from "react-i18next";
import { Row } from "common/components";
import { ControlLabel } from "components/bootstrap";
import OwnerLabel from "security-app/components/SecurityEvents/Alerts/EventDetails/OwnerLabel";
const OwnerAction = ({ securityEvent }) => {
  const { t } = useTranslation("enterprise_security_events");
  return /* @__PURE__ */ React.createElement(Row, { $gap: "xs", $align: "center", $width: "auto" }, /* @__PURE__ */ React.createElement(ControlLabel, { style: { margin: 0 } }, t("owner_action.owner")), /* @__PURE__ */ React.createElement(OwnerLabel, { securityEvent }));
};
export default OwnerAction;
